import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomersCrmStatisticsAPI from '../../../api/CustomersCrmStatisticsAPI';

type Props = { timeRange: { start: string; end: string } };

function CustomersCrmTotalCard({ timeRange }: Props) {
  const { t } = useTranslation();
  const [total, setTotal] = useState(0);

  useEffect(() => {
    let mounted = true;
    CustomersCrmStatisticsAPI.getCustomersTotal({ startTime: timeRange.start, endTime: timeRange.end })
      .then((res) => {
        if (!mounted) return;
        setTotal(res.data?.total || 0);
      })
      .catch(() => {
        if (!mounted) return;
        setTotal(0);
      });
    return () => { mounted = false };
  }, [timeRange.start, timeRange.end]);

  return (
    <div className="space-y-1">
      <p className="text-2xl font-bold text-foreground">{total}</p>
      <p className="text-sm text-muted-foreground">{t('stats.customers_total') || 'Customers'}</p>
    </div>
  );
}

export default CustomersCrmTotalCard;


